<template>
    <footer>
        <svg class="footer-decoration" width="600" height="80" viewBox="0 0 600 80" xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none">
            <path
                d="M44.0735 16L0 33V80H600V43L562.938 19.5L544.908 38L417.696 1L350.083 38L345.576 34L338.564 43L268.447 8L209.85 34L196.828 22L185.81 34L177.796 26.5L165.776 34L108.18 6.5L66.1102 22L44.0735 16Z" />
        </svg>

        <Container>
            <ul class="footer-items">
                <li class="footer-item">
                    <NuxtLink to="/">Accueil</NuxtLink>
                </li>
                <li class="footer-item">
                    <NuxtLink to="/landing-page">Landing page</NuxtLink>
                </li>
                <li class="footer-item">
                    <NuxtLink to="/websites">Websites</NuxtLink>
                </li>
                <li class="footer-item">
                    <NuxtLink to="/expertise">Expertise</NuxtLink>
                </li>
                <li class="footer-item">
                    <NuxtLink to="/contact">Contact</NuxtLink>
                </li>
            </ul>
            <canvas ref="footerCanvas" class="footer-canvas"></canvas>
        </Container>
    </footer>
</template>

<script setup>
import AnimationManager from '~/utils/classes/AnimationManager';
import TitleAnimation from '~/utils/classes/TitleAnimation';
import Particle from '~/utils/classes/primary/Particle';

const footerCanvas = ref(null);

onMounted(() => {

    /** @type {HTMLCanvasElement} */
    const $canvas = footerCanvas.value;
    /** @type { CanvasRenderingContext2D } */
    const ctx = $canvas.getContext("2d");
    /** @type { Particle[] } */
    let particleArray = [];

    function initTitle() {
        const adjustX = 3;
        const adjustY = 18;
        const particleSpacing = 2;

        ctx.font = "30px Courier New";
        ctx.textBaseline = "ideographic";
        ctx.letterSpacing = "-1px";
        ctx.wordSpacing = "-8px";
        ctx.fillText("Byte Hive", 0, 30);
        const textMeasure = ctx.measureText("Byte Hive");
        const textCoordinates = ctx.getImageData(
            0,
            0,
            textMeasure.width,
            textMeasure.fontBoundingBoxAscent + 3,
        );

        particleArray = [];
        const pixels_data = textCoordinates.data;

        let add = true
        for (let y = 0; y < textCoordinates.height; y++) {
            for (let x = 0; x < textCoordinates.width; x++) {
                const index = (y * textCoordinates.width + x) * 4;
                const a = pixels_data[index + 3];
                if (a > 0) {
                    if (add) {
                        let positionX = x + adjustX;
                        let positionY = y + adjustY;
                        particleArray.push(
                            new Particle(
                                positionX * particleSpacing,
                                positionY * particleSpacing,
                            ),
                        );
                    }
                    add = !add
                }
            }
        }
    }

    initTitle();
    const animationManager = new AnimationManager(
        $canvas,
        [
            new TitleAnimation($canvas, particleArray),
        ],
    );
    animationManager.animate();
})

</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
